// extracted by mini-css-extract-plugin
export default {"container":"y_wRS5","successIcon":"U7_LQw","errorIcon":"Ph6D4r"};